import React, { useEffect } from "react";
import FormSelect from "../../../../components/UI/formSelect/formSelect";
import Input from "../../../../components/UI/input/GgInput";
import FileButton from "../../../../components/UI/button/FileButton";
import { AddIcon } from "../../../../assets/icons";
import { IContent, IPMBlock } from "../../../../models/IPages";
import { getImageExtensionFromBase64 } from "../../../../utils";
import { Editor } from "../../../../components/UI/editor/QuillEditor";
import Button from "../../../../components/UI/button/GgButton";
import Emptiness from "../../../../components/UI/emptiness/Emptiness";
import Spinner from "../../../../components/UI/spinner/Spinner";
import Timofey from "../../../../assets/images/Timofey_avatar.png";
import { useModal } from "../../../../customHooks/useModal";
import { Context } from "../../../..";
import CONSTANTS from "../../../../utils/constants";


interface ISiteContent {
  _id?: string | undefined;
  title?: string;
  content?: string;
  actionData?: any;
}

function PrivacyPolicyBlock({ data, setData, articles, categoryType, actionData }: IPMBlock) {
  const { site } = React.useContext(Context);

  const [formData, setFormData] = React.useState<ISiteContent[]>([]);
  const [originalFormData, setOriginalFormData] = React.useState<
    ISiteContent[]
  >([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [privacyPolicy, setPrivacyPolicy] = React.useState<string>("");
  const [selectedCard, setSelectedCard] = React.useState<any>(null);

  const modal = useModal();

  useEffect(() => {
    site
      .loadList()
      .then((res: any) => {
        setFormData(res);
        setOriginalFormData(res);
        // if needed to get content by title

        // const content = Object.fromEntries(
        //   res.map((item: any) => [item.title, item.content])
        // );
        // console.log({ content });

        setPrivacyPolicy(res?.[0]?.content?.[0]);
          setLoading(false);
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site]);

  const updatePrivacyPolicy = () =>
    site.updateOne(CONSTANTS.privacyPolicy, { content: privacyPolicy });

  const showSelectedCard = (item: ISiteContent) => {
    if (item._id === selectedCard?._id) {
      setSelectedCard(null);
    } else {
      setSelectedCard(item);
    }
  };

  const handleChangeContent = (val: string, index: number, key: string) => {
    let modifiedSelected = { ...selectedCard };
    const newFormData = formData.map((item) => {
      if (item._id === selectedCard._id) {
        // @ts-ignore
        item.content[index][key] = val;
        modifiedSelected = item;
      }
      return item;
    });
    setSelectedCard(modifiedSelected);
    setFormData(newFormData);
  };

  const handleUpdateContent = () => {
    site
      .updateOne(selectedCard?.title, { content: selectedCard?.content })
      .then(() => setSelectedCard(null))
      .catch(console.log);
  };

  const stateNameLookup = {
    nsw: "New South Wales",
    vic: "Victoria",
    qld: "Queensland",
    sa: "South Australia",
    tas: "Tasmania",
    nt: "Northern Territory",
    act: "Australian Capital Territory",
    wa: "Western Australia",
  } as any;

  useEffect(()=>{
  },[originalFormData,formData])
 
  return (
    <>
      <div className="step-list col">
      {formData.length > 0 && !loading ? (
        <>
          <div className="title">Privacy Policy</div>
          {/* <JoditEditor
            value={privacyPolicy}
            onBlur={(newContent) => setPrivacyPolicy(newContent)}
            // onChange={(newContent) => {
            //   setPrivacyPolicy(newContent);
            // }}
            config={{
              height: "20rem",
            }}
            // config={{
            //   placeholder: 'Start typing...'
            // }}
          /> */}
          <Editor
          value={privacyPolicy}
          onChange={(value) => setPrivacyPolicy(value)}
          placeholder="Enter content"
          style={{
            height: "60vh",
            marginBottom: "3rem",
          }}
          readOnly={!actionData?.add && !actionData?.edit}
          />
          <div className="btn-container">
            {actionData?.edit || actionData?.delete ? (
              <>
              <Button
                // className="button"
                label="Save page"
                onPress={updatePrivacyPolicy}
                />
              </>
            ): ""}
          </div>
        </>
      ) : formData.length === 0 && !loading ? (
        <Emptiness icon={Timofey} content="No content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
      </div>
    </>
  );
}

export default PrivacyPolicyBlock;
